export const uiSettings = {
    headerFontSize: '1.45rem',
};
